import { useEffect, useState } from 'react'
import { ceramicPackages } from '../data/protection-catalog'
import { fetchCeramicPackageRows, mergeCeramicPackages } from './ceramic-packages'

export { featuredPackageIndex } from './protection-carousel'

export function useCeramicPackages() {
  const [packages, setPackages] = useState(() => ceramicPackages)

  useEffect(() => {
    let active = true

    fetchCeramicPackageRows()
      .then((rows) => {
        if (!active) return
        setPackages(mergeCeramicPackages(rows))
      })
      .catch(() => {
        if (!active) return
        setPackages(ceramicPackages)
      })

    return () => {
      active = false
    }
  }, [])

  return packages
}
